export enum PacketType {
    ClientWelcome,
    ClientList,
    UpdateTransform,
    ChatSend,
    Ping,
    BecomeHost,
    CreateObject,
    UpdateScript,
    PlayerJoin,
    PlayerLeave,
    RequestJoin,
    RemoveObject,
    CreateScript,
    UpdateObject,
    SetPlayerClass,
    DamagePlayer,
    RestoreEnergy,
    HealPlayer
}